// extracted by mini-css-extract-plugin
export var accordion = "_hr-0";
export var chevron = "_hr-3";
export var closed = "_hr-2";
export var content = "_hr-4";
export var open = "_hr-1";
export var rotate = "_hr-5";